import {useEffect, useState} from "react";
import {findCustomerFilterCustomersWithPagination} from "../api/customerApiClient";

export const useCustomerFilterCustomers = (customerFilterId, page, pageSize, reloadTrigger) => {
    const [customerFilter, setCustomerFilter] = useState({});
    const [customerFilterCustomers, setCustomerFilterCustomers] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const customerFilterCustomersWithPagination = findCustomerFilterCustomersWithPagination(customerFilterId, page, pageSize, abortController.signal);

        customerFilterCustomersWithPagination
            .then(
                (data) => {
                    const customerFilter = data.customerFilter;
                    const customerFilterCustomers = data.customerFilterCustomers;
                    const pagination = data.pagination;

                    setCustomerFilter(customerFilter)
                    setCustomerFilterCustomers(customerFilterCustomers)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [customerFilterId, page, pageSize, reloadTrigger]);

    return {customerFilter: customerFilter, customerFilterCustomers : customerFilterCustomers, pagination};
};